export const getSayHelloFormAllCoursesAPIRequest = async (domain: string) => {
  return await fetch(`${process.env.REACT_APP_API_URL}/university/${domain}/courses`).then((res) => res.json());
};
